import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import pt from 'vuetify/lib/locale/pt'

Vue.use(Vuetify);

export default new Vuetify({
	lang: {
		locales: { pt },
		current: 'pt',
	},
	theme: {
		themes: {
			light: {
				primary: '#00006F',
				secondary: '#2B5672',
				accent: '#F3B806',
				error: '#C62828',
				warning: '#ED8B00',
				info: '#2B5672',
				success: '#2E7D32',
				background: '#F7F8FA',
				surface: '#FFFFFF',
				'on-primary': '#FFFFFF',
				'on-secondary': '#FFFFFF',
				'on-surface': '#212121',
				'on-background': '#212121'
			},
			dark: {
				primary: '#4D4DA3',
				secondary: '#8EA6B6',
				accent: '#F3B806',
				error: '#EF7373',
				warning: '#F5A623',
				info: '#75A6C5',
				success: '#66BB6A',
				background: '#0F1117',
				surface: '#171A22',
				'on-primary': '#FFFFFF',
				'on-secondary': '#FFFFFF',
				'on-surface': '#FFFFFF',
				'on-background': '#FFFFFF'
			}
		}
	}
});
